export const SET_STEP = '[STEP] SET STEP';
export const REMOVE_STEP = '[REGISTER] REMOVE STEP';

export function setStep(value)
{
    return {
        type: SET_STEP,
        payload: value
    };
}

export function removeStep()
{
    return {
        type: REMOVE_STEP
    }
}

